import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=f96eac6e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=f96eac6e&prod&lang=css"
import style1 from "./Register.vue?vue&type=style&index=1&id=f96eac6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96eac6e",
  null
  
)

export default component.exports